import { getUserToken } from '@/lib/firebase';
import axios from 'axios';

const apiClient = axios.create({
    // baseURL: `http://127.0.0.1:5001/studict-api-9130d/asia-northeast1/admin/`,
    baseURL: `https://admin-pt4uv7jusa-an.a.run.app/`,
});

apiClient.interceptors.request.use(
    async (config) => {
        const token = await getUserToken();
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default apiClient;
